module.exports = "/_next/static/images/daily-star-badge-daa831caa75fbe5c438e6fdb3182d944.webp";